import React from "react";
import { Icon } from "../";

/**
 * Banner component to inform users about POS integration restrictions
 * Displays when a business has an active POS integration
 */
const POSIntegrationBanner = () => {
  return (
    <div
      className="ordering-catalog-surface border-primary/30 bg-accent rounded-lg border p-3 shadow-[var(--od-shadow-1)] sm:p-4"
      data-ordering-expression="product"
    >
      <div className="flex items-center gap-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="border-primary/30 bg-primary/20 flex h-9 w-9 items-center justify-center rounded-lg border sm:h-10 sm:w-10">
            <Icon name="Info" className="text-primary h-4 w-4 sm:h-5 sm:w-5" />
          </div>
        </div>

        {/* Content */}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-3">
            <h3 className="text-sm font-semibold text-white sm:text-base">
              POS Integration Active
            </h3>
            <div className="text-foreground flex items-center gap-4 text-xs sm:text-sm">
              <div className="flex items-center gap-1.5">
                <Icon
                  name="CheckCircle"
                  className="text-primary h-3.5 w-3.5 flex-shrink-0"
                />
                <span>Activate/deactivate products</span>
              </div>
              <div className="flex items-center gap-1.5">
                <Icon
                  name="XCircle"
                  className="text-muted-foreground h-3.5 w-3.5 flex-shrink-0"
                />
                <span>No create/edit/delete</span>
              </div>
            </div>
          </div>
          <p className="text-primary/80 mt-2 text-xs">
            Changes must be made in your POS system or disconnect the
            integration first.
          </p>
        </div>
      </div>
    </div>
  );
};

export default POSIntegrationBanner;
